const addContent = ()=>import('./views/addContent.vue');
const contentList = ()=>import('./views/contentList.vue');
const contentMan = ()=>import("./views/contentMan.vue");

export default {
  //内容管理
  path: 'content',
  name: 'contentBox',
  component: contentMan,
  meta: {
    root: '/inforMan'
  },
  children: [
    {
      path: '/contentList',
      name: 'contentList',
      component: contentList,
      meta: {
        title: '内容列表',
        root: '/inforMan'
      }
    },
    {
      // 添加内容
      path: '/addContent',
      name: 'addContent',
      component: addContent,
      meta: {
        parentRoot: '/contentList', // 导航高亮
        root: '/inforMan'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/core/modules/content/router.js